// Routes for the public (logged-out) storefront app.
//
// Two bases share one layout: /storefront/* is the standalone page and /menu-widget/* is the
// embeddable iframe. They render the same blade and mount point, so one router serves both and
// meta.view tells the layout which it is.

import StorefrontView from "@/storefront/StorefrontView.vue";
import { makeListingRoutes } from "@/routes/marketplaceRoutes";

const StorefrontListing = () => import("@/pages/marketplace/search/MarketplaceSearchView.vue");
const ProductPage = () => import("@/pages/productPage/ProductPage.vue");

// A menu with no vendor slug has nothing to show; the layout renders its "no longer available"
// panel rather than the router 404ing on a bare /storefront.
const missingVendor = (path, view) => ({
  path,
  component: StorefrontView,
  meta: { view },
});

const base = (path, namePrefix, view) => ({
  path,
  component: StorefrontView,
  meta: { view },
  props: true,
  children: makeListingRoutes({
    namePrefix,
    listing: StorefrontListing,
    product: ProductPage,
    meta: { view },
  }),
});

export default [
  base("/storefront/:vendorSlug", "storefront", "profile"),
  base("/menu-widget/:vendorSlug", "widget", "widget"),
  missingVendor("/storefront", "profile"),
  missingVendor("/menu-widget", "widget"),
];
